/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Progress_RecordInputs */

const en_platform_progress_record = /** @type {(inputs: Platform_Progress_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record`)
};

const pl_platform_progress_record = /** @type {(inputs: Platform_Progress_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekord`)
};

/**
* | output |
* | --- |
* | "Record" |
*
* @param {Platform_Progress_RecordInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_progress_record = /** @type {((inputs?: Platform_Progress_RecordInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Progress_RecordInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_progress_record(inputs)
	return en_platform_progress_record(inputs)
});